import React from "react";
import { DateTime } from "luxon";

import useCalendarPreferences from "app/utils/hooks/useCalendarPreferences";
import { formatTime } from "app/utils/luxonFormats";
import styles from "./styles.module.scss";

type PropsDef = {
  event: any;
  timeText: string;
  timeZone?: string;
};

export default function Program(props: PropsDef) {
  const { durationInMinutes } = props.event.extendedProps;
  const { preferences } = useCalendarPreferences();
  const startTimeString = formatTime(
    DateTime.fromJSDate(props.event.start, { zone: props.timeZone }),
    preferences.timeFormat,
  );
  return (
    <div
      className={`${styles.event_container} ${
        durationInMinutes < 30 ? styles.small_event : ""
      }`}
    >
      <div className={styles.program_bar}></div>

      <div className={styles.lesson_schedule_event}>
        <div className={styles.event_title}>{props.event.title}</div>
        <div className={styles.event_time}>{startTimeString}</div>
      </div>
    </div>
  );
}
